import * as NavigationConstants from './NavigationConstants';

export const setNavigationKey = (key) => {
  return {
    type: NavigationConstants.SET_NAVIGATION_KEY,
    key: key
  };
};
